import { Header, Modal, PrimaryButton, TertiaryButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetCategoryBudgetSettings } from './BudgetCategoryBudgetSettings'
import messages from './messages'

export interface BudgetCategoryBudgetSettingsModalProps {
  open?: boolean
  onDismiss?(): void
  isBudgetOverageEnabled: boolean
  haveSettingsChanged: boolean
  savingSettings: boolean
  onBudgetOverageChange: () => void
  saveBudgetSettingsChanges: () => void
}

export const BudgetCategoryBudgetSettingsModal = ({
  open = false,
  onDismiss = () => undefined,
  isBudgetOverageEnabled,
  haveSettingsChanged,
  savingSettings,
  onBudgetOverageChange,
  saveBudgetSettingsChanges,
}: BudgetCategoryBudgetSettingsModalProps) => {
  const intl = useProcurifyIntl()

  return (
    <Modal
      maxWidth='sm'
      open={open}
      onClose={onDismiss}
      aria-labelledby='budget-category-budget-settings-modal-title'
    >
      <Modal.Card>
        <Modal.Header onClose={onDismiss}>
          <Header as='h5' id='budget-category-budget-settings-modal-title'>
            {intl.formatMessage(messages.budgetSettingsModalTitle)}
          </Header>
        </Modal.Header>
        <Modal.Content>
          <BudgetCategoryBudgetSettings
            isBudgetOverageEnabled={isBudgetOverageEnabled}
            onBudgetOverageChange={onBudgetOverageChange}
          />
        </Modal.Content>
        <Modal.Footer>
          <TertiaryButton onClick={onDismiss}>
            {intl.formatMessage(messages.budgetSettingsCancelButtonText)}
          </TertiaryButton>
          <PrimaryButton
            disabled={!haveSettingsChanged || savingSettings}
            onClick={saveBudgetSettingsChanges}
          >
            {intl.formatMessage(messages.budgetSettingsSaveButtonText)}
          </PrimaryButton>
        </Modal.Footer>
      </Modal.Card>
    </Modal>
  )
}

BudgetCategoryBudgetSettingsModal.displayName =
  'BudgetCategoryBudgetSettingsModal'
